<template>
	<div class="video-box">
		<video
			class="my-video"
			ref="videoPlayer"
			:controls="controls"
			:autoplay="autoplay"
			width="163"
			height="116"
			:poster="poster"
		>
			<!-- @loadeddata="onVideoLoaded"
			@ended="onVideoEnded" -->
			<source :src="videoSrc" type="video/mp4" />
			您的浏览器不支持视频标签。
		</video>
		<img
			v-if="showPlayBtn"
			:src="require('@/assets/images/Videopublicity-play.png')"
			class="play-btn"
		/>
	</div>
</template>

<script>
export default {
	props: {
		videoSrc: {
			type: String,
			required: true
		},
		poster: String,
		controls: {
			type: Boolean,
			default: false
		},
		autoplay: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showPlayBtn: true
		};
	},
	methods: {
		// onVideoLoaded(event) {
		// 	// 视频加载完毕后的处理逻辑
		// 	// console.log('视频已加载', event);
		// },
		// onVideoEnded(event) {
		// 	// 视频播放结束后的处理逻辑
		// 	// console.log('视频播放结束', event);
		// },
		play() {
			this.$refs.videoPlayer.play();
			this.goFullScreen();
			this.showPlayBtn = false;
		},
		pause() {
			this.$refs.videoPlayer.pause();
			this.showPlayBtn = true;
		},
		goFullScreen() {
			const video = this.$refs.videoPlayer;
			if (video.requestFullscreen) {
				video.requestFullscreen();
			} else if (video.mozRequestFullScreen) {
				/* Firefox */
				video.mozRequestFullScreen();
			} else if (video.webkitRequestFullscreen) {
				/* Chrome, Safari & Opera */
				video.webkitRequestFullscreen();
			} else if (video.msRequestFullscreen) {
				/* IE/Edge */
				video.msRequestFullscreen();
			}
		}
	},
	beforeDestroy() {
		// 清理资源，比如停止视频播放
		this.$refs.videoPlayer.pause();
	}
};
</script>

<style scoped>
.video-box {
	position: relative;
	font-size: 0;
}

.my-video {
	width: 100%;
	object-fit: cover;
}
.play-btn {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 62px;
}
</style>
